"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "block" };
const SvgIcon_vue_1 = __importDefault(require("@SharedVueComponents/SvgIcon/SvgIcon.vue"));
const store_1 = require("@/state/store");
exports.default = (0, vue_1.defineComponent)({
    __name: 'BenefitItems',
    props: {
        items: {}
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("ul", {
                class: (0, vue_2.normalizeClass)((0, vue_2.unref)(store_1.store).isLandingPage ? 'grid gap-6 lg:grid-cols-[repeat(4,auto)] lg:gap-4' : 'grid gap-3 text-sm')
            }, [
                ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(_ctx.items, (item, i) => {
                    return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("li", {
                        key: `item-${i}`,
                        class: (0, vue_2.normalizeClass)(["flex items-center", (0, vue_2.unref)(store_1.store).isLandingPage ? 'py-1.5' : ''])
                    }, [
                        (item.iconName)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(SvgIcon_vue_1.default, {
                                key: 0,
                                "icon-name": item.iconName,
                                class: "mr-2 block size-10 shrink-0"
                            }, null, 8, ["icon-name"]))
                            : (0, vue_2.createCommentVNode)("", true),
                        (0, vue_2.createElementVNode)("div", {
                            class: (0, vue_2.normalizeClass)(["text-sm", { 'lg:text-xs': (0, vue_2.unref)(store_1.store).isLandingPage }])
                        }, [
                            (0, vue_2.createElementVNode)("b", {
                                class: (0, vue_2.normalizeClass)(["block font-semibold", (0, vue_2.unref)(store_1.store).isLandingPage ? 'pb-1' : ''])
                            }, (0, vue_2.toDisplayString)(item.title), 3),
                            (0, vue_2.createElementVNode)("span", _hoisted_1, (0, vue_2.toDisplayString)(item.description), 1)
                        ], 2)
                    ], 2));
                }), 128))
            ], 2));
        };
    }
});
